import { useContext, useState } from 'react'

import { values } from 'lodash'
import { Divider, message } from 'antd'
import { useSelector } from 'react-redux'
import { faFileContract } from '@fortawesome/pro-solid-svg-icons'

import { getEntityFromProperty, InstitutionConstraint, InstitutionConstraintValidators, InstitutionConstraintProperties as Properties } from '../../../utils/entities/institutionConstraints'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import FormFooter from '../../../Components/antd/Forms/FormFooter'
import InstitutionConstraintsSelector from '../../../Components/shared/Selectors/InstitutionConstraints/InstitutionConstraintsSelector'
import { selectUser } from '../../../reducers/UserReducer'
import { firstOrDefault } from '../../../utils'
import FormItem from '../../../Components/shared/Forms/FormItem'
import { isValid } from '../../../utils/validators'
import { GlobalContext } from '../../GlobalProvider'
import { onError } from '../../../utils/apiHelper'

export const BODY_STYLE = { display: 'flex', flexDirection: 'column', height: '93%', width: '100%' }
export const SELECT_STYLE = { width: '200px' }

message.config({
  top: 20,
  duration: 3,
  maxCount: 1,
  placement: 'topRight'
})

const InstitutionConstraintForm = ({ data, disabled, toFilter = [], onSubmit, onCancel }) => {
  const { studentMetadata: constraintProperties } = useContext(GlobalContext)

  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const institution = firstOrDefault(user.institutions)

  const [formData, setFormData] = useState(new InstitutionConstraint(data ? { ...data, institution } : { institution }))

  const handleSubmit = event => {
    const errors = isValid(formData, values(InstitutionConstraintValidators))

    if (errors.keys.length > 0) {
      onError(t('institution_constraint.create.error'))
    } else {
      onSubmit(new InstitutionConstraint(formData))
    }
  }

  const handleChange = propertyName => setFormData(formData => ({ ...formData, [Properties.PROPERTY_NAME]: propertyName, [Properties.ENTITY_NAME]: getEntityFromProperty(propertyName) }))

  return (
    <div className='institution-constraint-form pd-12'>
      <FormItem className='form-select' icon={faFileContract} label='form.label.constraint_type' required>
        <InstitutionConstraintsSelector
          institutionConstraints={constraintProperties.filter(p => !toFilter.includes(p))}
          disabled={disabled}
          values={formData.propertyName}
          onChange={handleChange}
          style={{ marginTop: '8px' }}
        />
      </FormItem>

      <Divider className='divider-0' />

      <FormFooter
        disabled={disabled}
        cancel={{ text: t('modal.cancel_button') }}
        submit={{ text: t('modal.ok_button.save') }}
        remove={null}
        onCancel={onCancel}
        onSubmit={handleSubmit}
      />
    </div>
  )
}

export default InstitutionConstraintForm